import { Values } from '@lib/interfaces/form';
import getPhoneNumberValueFromQueryData from '@lib/utils/getPhoneNumberValueFromQueryData';

export default function getDefaultValuesFromQueryData(data?: Values): Values {
  return {
    ...data,
    phoneNumber: getPhoneNumberValueFromQueryData(data),
  };
}
